























import VueOptions from '@utils/VueOptions'
import Modal from '@components/Modal'
import IntroTutorialStep from './IntroTutorialStep'
import StorageTutorialStep from './StorageTutorialStep'
import DistributeTutorialStep from './DistributeTutorialStep'
import SendRecapTutorialStep from './SendRecapTutorialStep'

settings =
  name: 'ItemDistributionTutorialModal'
  vue:
    props: ['show']

    components: {
      Modal,
    }

    data: ->
      currentIndex: 0

    computed:
      components: ->
        [
          IntroTutorialStep,
          StorageTutorialStep,
          DistributeTutorialStep,
          SendRecapTutorialStep,
        ]

    methods:
      hiClose: ->
        @$emit 'update:show', false

      hiBack: ->
        @currentIndex-- if @currentIndex > 0

      hiNext: ->
        @currentIndex++ if @currentIndex < @components.length - 1

    watch:
      show: ->
        @currentIndex = 0 if @show

export default VueOptions.vue settings
